import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

import { CardType, useGetCommentQuery } from '../../../../graphql/gen/types';
import { slateNodesToString } from '../../../../utils/slate';
import { CreateFactDialogContent } from './CreateFactDialog';

type Props = {
  commentId: string;
};

export function FactFromCommentDialog({ commentId }: Props): React.ReactElement {
  const { data: commentData, loading: commentLoading } = useGetCommentQuery({ variables: { commentId } });
  const boardId =
    commentData?.loggedIn?.commentById?.question?.boardId ||
    commentData?.loggedIn?.commentById?.post?.plex?.defaultBoardId;
  const commentBody = commentData?.loggedIn?.commentById?.body;
  if (commentLoading || commentBody == null || boardId == null) {
    return <Skeleton variant="text" />;
  } else {
    return (
      <CreateFactDialogContent boardId={boardId} initialText={slateNodesToString(commentBody)} type={CardType.Faq} />
    );
  }
}
